import React, { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Modal, Button, Input, Icon, Table } from 'antd';
import TextEvents from 'app/components/TextEvents';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import * as TrainingActions from '../../../actions/TrainingActions';

const ModalAssignation = (props) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const dispatch = useDispatch();
    const {siteId} = useSelector(state => state.Auth)

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('');
    };

    const {
        isLoadEmployee,
        listEmployeeId,
        listEmployee,
        isSaveEmployee
    } = useSelector(state => state.TrainingReducer);

    const dataSource = listEmployee.map(
        (record) => {
            return {
                'key': record.employeeId,
                'ficha': record.employeeId,
                'nombre': record.name,
                'puesto': record.categoryName,
                'compañia': record.company
            }
        }
    );

    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input

                    placeholder={`Buscar...`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                //setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        props.setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(selectedRows);
        dispatch(TrainingActions.saveAdmin(selectedRowKeys));
    }

    const rowSelection = {
        selectedRowKeys: props.selectedRowKeys,
        selectedRows: selectedRows,
        onChange: onSelectChange
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
            ellipsis: true,
            width: 250,
            ...getColumnSearchProps('nombre')
        },
        {
            title: 'Ficha',
            dataIndex: 'ficha',
            key: 'ficha',
            ellipsis: true,
            width: 100,
            ...getColumnSearchProps('ficha')
        },
        {
            title: 'Puesto',
            dataIndex: 'puesto',
            key: 'puesto',
            ellipsis: true,
            width: 200,
            ...getColumnSearchProps('puesto')
        },
        {
            title: 'Compañía',
            dataIndex: 'compañia',
            key: 'compañia',
            ellipsis: true,
            width: 250,
            ...getColumnSearchProps('compañia')
        }
    ];

    const submit = () => {
        dispatch(TrainingActions.insUpdEmployeeTraining({
            idTraining: props.idTraining,
            listEmployeeId: listEmployeeId.join(",")
        }, () => {
            props.setVisibleModalAssign(false);
            dispatch(TrainingActions.getNames());
            dispatch(TrainingActions.getSubdirections());
        }));
    }

    return (
        <Modal
            destroyOnClose={true}
            onCancel={() => props.setVisibleModalAssign(false)}
            visible={props.visibleModalAssign}
            width={1000}
            title={
                <div>

                    <Grid container direction="row">
                        <Grid item xs={8}>
                            <TextEvents
                                text={'Administradores asignados'}
                                color='cotemar'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextEvents
                                text={'Asignados ' + listEmployeeId.length + '/' + listEmployee.length + ' Total'}
                                color='cotemar'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                    </Grid>
                    <TextEvents
                        text={'Tipo de Capacitación ' + props.trainingName}
                        color='cotemar'
                        size='label'
                        weight='bold'
                    />
                </div>
            }
            centered={true}
            footer={[
                <Button key="back" type="danger" ghost onClick={() => props.setVisibleModalAssign(false)}>
                    Cancelar
                </Button>,
                siteId === "HUB"?
                <Button key="submit" type="primary" loading={isSaveEmployee} onClick={() => submit()} >
                    Guardar
                </Button>:null,
            ]}
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                scroll={{ y: 350 }}
                pagination={false}
                loading={isLoadEmployee}
                rowSelection={rowSelection}
            />
        </Modal>
    )
}

export default ModalAssignation;